/* RESPONSIBLE TEAM: team-inbox-experience */
import Rule from 'embercom/models/inbox/conversation-rules/rule';

export default Rule.extend({
  entityString: 'tag_rule',
  subRouteString: 'tags',
  allowedRuleActions: ['add-tag-to-conversation'],
});
